export default __webpack_public_path__ + "static/media/topblock-section.6259975b.svg";